import { render } from "./GalleryBoard.vue?vue&type=template&id=96bf217e&scoped=true"
import script from "./GalleryBoard.vue?vue&type=script&lang=js"
export * from "./GalleryBoard.vue?vue&type=script&lang=js"

import "./GalleryBoard.vue?vue&type=style&index=0&id=96bf217e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96bf217e"]])

export default __exports__